import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const createEquipment = (_, params) => {
  return Api(endPoints.createEquipment, params, requestType.POST);
};

const updateEquipment = (id, params) => {
  return Api(`${endPoints.updateEquipment}/${id}`, params, requestType.PUT);
};

const getAllEquipment = (params) => {
  return Api(
    `${endPoints.getEquipment}?tarrif=${params}`,
    null,
    requestType.GET
  );
};

export { createEquipment, updateEquipment, getAllEquipment };
